<script setup lang="ts">
import { ref, toRef } from "vue";
import LoadingText from "../UI/skeleton/LoadingText.vue";
import { useGetDiagnostics } from "@/stores/queries";
import DiagnosticsList from "./DiagnosticsList.vue";
import CreateDiagnosticsBanner from "./CreateDiagnosticsBanner.vue";
import { useDeviceState } from "@/stores/DeviceState";

const props = defineProps<{
  projectId: number;
  readonly?: boolean;
  projectColor?: string;
}>();
const device = useDeviceState();

const projectId = toRef(props, "projectId");

const { data: diagnostics, isPending: isLoadingDiagnostics } =
  useGetDiagnostics(
    ref({
      skip: 0,
      take: 100,
      sortBy: "createdAt",
      order: "desc",
    }),
    projectId
  );
</script>

<template>
  <template v-if="device.isOnline">
    <LoadingText
      v-if="isLoadingDiagnostics"
      class="mb-3"
      :text="$t('report:diagnostics.load.inspections')"
    />
    <div v-else-if="!diagnostics?.length" class="pt-3">
      <CreateDiagnosticsBanner :project-id="projectId" />
    </div>

    <div v-else-if="diagnostics">
      <DiagnosticsList
        :diagnostics="diagnostics ?? []"
        :projectId="projectId"
      />
    </div>
  </template>
</template>
